import React, { useState } from 'react';
import { Box, Typography, CircularProgress, Alert, Button } from '@mui/material';
import EventsList from '../components/events/EventsList';
import { useEvents } from '../contexts/EventsContext';
import { useNavigate } from 'react-router-dom';
import { useUserFavorites } from '../hooks/useUserFavorites';
import { useUser } from '../contexts/UserContext';

const Events: React.FC = () => {
  const { events, loading, error } = useEvents();
  const { user } = useUser();
  const { favorites, loading: favoritesLoading } = useUserFavorites();
  const [filterMode, setFilterMode] = useState<'favorites' | 'all'>('all');
  const navigate = useNavigate();

  // Debug: log the first event to inspect its structure
  if (events.length > 0) {
    // eslint-disable-next-line no-console
    console.log('Sample event object:', events[0]);
  }

  const handleFilterChange = (
    event: React.MouseEvent<HTMLElement>,
    newFilter: 'favorites' | 'all' | null,
  ) => {
    if (newFilter !== null) {
      setFilterMode(newFilter);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <EventsList 
          filterMode={filterMode}
          userFavorites={favorites}
          userHighSchool={user?.schoolName}
          onFilterChange={handleFilterChange}
        />
      )}
    </Box>
  );
};

export default Events; 